'use strict';

angular.module('cca.components.ccaCancelOrDeleteEventsConfirmDialog',
    [])
    .component('ccaCancelOrDeleteEventsConfirmDialog',
        {
            bindings: {
                resolve: '<',
                modalInstance: '<',
            },
            templateUrl: '/Scripts/app/cca/components/cca-cancel-or-delete-events-confirm-dialog.template.html',
            controller: class CcaCancelOrDeleteEventsConfirmDialogCtrl
            {
                $filter: any;
                $timeout: any;
                $uibModal: any;
                $window: any;

                dateTimeService: any;
                diaryService: any;
                signUpRepository: any;
                simpleAlertService: any;

                modalInstance: any;

                eventsToBeCancelledOrDeleted: any[] = [];
                cancelOrDeleteEventsData: any;

                // One row per day, so a multi-day event is listed more than once. Kept apart
                // from dataItems, which is what gets counted and sent (SB-16525).
                displayItems: any[] = [];

                static $inject = ['$window', 'dateTimeService', 'diaryService', 'signUpRepository', 'simpleAlertService'];

                constructor($window, dateTimeService, diaryService, signUpRepository, simpleAlertService)
                {
                    this.$window = $window;

                    this.dateTimeService = dateTimeService;
                    this.diaryService = diaryService;
                    this.signUpRepository = signUpRepository;
                    this.simpleAlertService = simpleAlertService;
                };

                $onChanges(changes)
                {
                    if (changes.resolve)
                    {
                        this.cancelOrDeleteEventsData = changes.resolve.currentValue?.cancelOrDeleteEventsData;

                        // Expand a copy: insertMultiDayEvents pushes the extra days into the
                        // array it is given, which would add duplicate ids to dataItems.
                        this.displayItems = this.diaryService.insertMultiDayEvents(this.cancelOrDeleteEventsData.dataItems.slice())
                            .sort(function (a, b) { return a.eventDate - b.eventDate; });
                    }
                };

                getDateLabels(date)
                {
                    let dateLabels = this.dateTimeService.getDateLabels(date);
                    return dateLabels;
                };

                isToday(date)
                {
                    let now = moment();
                    let dateMoment = moment(date);
                    return dateMoment.isSame(now, 'd');
                };

                hasDateChangedSinceLastRow(thisIndex)
                {
                    let events = this.displayItems;

                    if (!Array.isArray(events))
                    {
                        return false;
                    }

                    if (thisIndex === 0)
                    {
                        return true;
                    }

                    let lastIndex = thisIndex - 1;

                    let date1 = moment(events[thisIndex].eventDate, 'DD-MM-YYYY');
                    let date2 = moment(events[lastIndex].eventDate, 'DD-MM-YYYY');

                    return !date1.isSame(date2, 'day');
                };

                closeModal(responseDto)
                {
                    this.modalInstance.close(responseDto);
                };

                confirm()
                {
                    let response =
                    {
                        status: 'confirm'
                    };
                    this.closeModal(response);
                }

                cancel()
                {
                    let response =
                    {
                        status: 'cancel'
                    };

                    this.closeModal(response);
                };
            }
        });
